export enum ContentDensity {
  Cozy = 'Cozy',
  Compact = 'Compact'
}
